@if (highlightedConditions.length > 0 || highlightedActions.length > 0 || highlightedActionsPersistent.length > 0) {
  <div class="highlights">
    @for (entityCondition of highlightedConditions | trackUUID; track entityCondition._trackUUID) {
      <span
        class="item"
        [conditionHighlight]="entityCondition"
        [ngClass]="{
          apply:
            settingsManager.settings.applyConditions &&
            settingsManager.settings.activeApplyConditions &&
            !entityCondition.expired &&
            !settingsManager.settings.activeApplyConditionsExcludes.includes(entityCondition.name) &&
            entityCondition.types.includes(ConditionType.apply),
          double: entityCondition.types.includes(ConditionType.double)
        }"
      >
        @if (
          settingsManager.settings.applyConditions &&
          settingsManager.settings.activeApplyConditions &&
          !entityCondition.expired &&
          settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) === -1 &&
          entityCondition.types.includes(ConditionType.apply)
        ) {
          <a
            class="close"
            [conditionHighlight]="entityCondition"
            ghs-pointer-input
            (singleClick)="declineApplyCondition(entityCondition, $event)"
          >
            <img class="ghs-svg" src="./assets/images/close_dialog.svg" />
          </a>
        }
        <span class="condition-image">
          <img
            [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/condition/' + entityCondition.name + '.svg'"
          />
          @if (entityCondition.types.includes(ConditionType.value)) {
            <span class="value">{{ entityCondition.highlightValue || entityCondition.value }}</span>
          }
        </span>
        @if (
          settingsManager.settings.applyConditions &&
          settingsManager.settings.activeApplyConditions &&
          !entityCondition.expired &&
          settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) === -1 &&
          entityCondition.types.includes(ConditionType.apply) &&
          entityCondition.types.includes(ConditionType.double)
        ) {
          <a
            class="double"
            [conditionHighlight]="entityCondition"
            ghs-pointer-input
            (singleClick)="applyCondition(entityCondition, $event, true)"
          >
            <img [src]="'./assets/images' + (settingsManager.settings.fhStyle ? '/fh' : '') + '/attackmodifier/icons/double.png'" />
          </a>
        }
        @if (
          settingsManager.settings.applyConditions &&
          settingsManager.settings.activeApplyConditions &&
          !entityCondition.expired &&
          settingsManager.settings.activeApplyConditionsExcludes.indexOf(entityCondition.name) === -1 &&
          entityCondition.types.includes(ConditionType.apply)
        ) {
          <a class="check" [conditionHighlight]="entityCondition" ghs-pointer-input (singleClick)="applyCondition(entityCondition, $event)">
            <img class="ghs-svg" src="./assets/images/check.svg" />
          </a>
        }
      </span>
    }

    @for (action of highlightedActions | trackUUID; track action._trackUUID) {
      <span class="item apply">
        <a class="close" ghs-pointer-input (singleClick)="changeAction(action, false, false)">
          <img class="ghs-svg" src="./assets/images/close_dialog.svg" />
        </a>

        <ghs-action [action]="action"></ghs-action>

        <a class="check" ghs-pointer-input (singleClick)="changeAction(action, true, false)">
          <img class="ghs-svg" src="./assets/images/check.svg" />
        </a>
      </span>
    }

    @for (action of highlightedActionsPersistent | trackUUID; track action._trackUUID) {
      <span class="item apply">
        <a class="close" ghs-pointer-input (singleClick)="changeAction(action, false, true)">
          <img class="ghs-svg" src="./assets/images/close_dialog.svg" />
        </a>

        <ghs-action [action]="action"></ghs-action>

        <a class="check" ghs-pointer-input (singleClick)="changeAction(action, true, true)">
          <img class="ghs-svg" src="./assets/images/check.svg" />
        </a>
      </span>
    }
  </div>
}
